import type { UserSummary } from '../../../api/types'

export function AssigneeStack({ users, max = 3 }: { users: UserSummary[]; max?: number }) {
  if (users.length === 0) return null
  const shown = users.slice(0, max)
  const overflow = users.length - shown.length

  return (
    <div style={{ display: 'flex', alignItems: 'center' }} title={users.map((u) => u.displayName).join(', ')}>
      {shown.map((user, index) => (
        <span
          key={user.id}
          style={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            background: 'var(--accent-soft)',
            color: 'var(--accent-10)',
            fontSize: '10px',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid var(--surface-2)',
            marginLeft: index === 0 ? 0 : -8,
            textTransform: 'uppercase',
            overflow: 'hidden',
          }}
        >
          {user.avatarUrl ? (
            <img src={user.avatarUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            user.displayName
              .split(' ')
              .map((p) => p[0])
              .slice(0, 2)
              .join('')
          )}
        </span>
      ))}
      {overflow > 0 ? (
        <span
          style={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            background: 'var(--surface-3)',
            color: 'var(--text-secondary)',
            fontSize: '10px',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid var(--surface-2)',
            marginLeft: -8,
          }}
        >
          +{overflow}
        </span>
      ) : null}
    </div>
  )
}
